import React from 'react';
import { createRoot } from 'react-dom/client';
// Redux
// https://github.com/rt2zz/redux-persist
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { App } from './App';
import { AuthProvider } from './context/AuthContext';
import reportWebVitals from './reportWebVitals';
import store, { persistor } from './setup/redux/Store';

// Apps

const root = createRoot(document.getElementById('root') as Element);

root.render(
    <Provider store={store}>
        {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
        <PersistGate persistor={persistor} loading={<div>Loading..index..</div>}>
            <AuthProvider>
                <App />
            </AuthProvider>
        </PersistGate>
    </Provider>,
);
reportWebVitals();
